import * as React from 'react';
import clsx from 'clsx';
import Fade from '@mui/material/Fade';
import { styled, useThemeProps } from '@mui/material/styles';
import { unstable_composeClasses as composeClasses } from '@mui/material';
import { TransitionGroup } from 'react-transition-group';
import { getPickersFadeTransitionGroupUtilityClass } from './pickersFadeTransitionGroupClasses';
import { jsx as _jsx } from "react/jsx-runtime";

var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes;
  var slots = {
    root: ['root']
  };
  return composeClasses(slots, getPickersFadeTransitionGroupUtilityClass, classes);
};

var animationDuration = 500;
var PickersFadeTransitionGroupRoot = styled(TransitionGroup, {
  name: 'MuiPickersFadeTransitionGroup',
  slot: 'Root',
  overridesResolver: function overridesResolver(_, styles) {
    return styles.root;
  }
})({
  display: 'block',
  position: 'relative'
});
/**
 * @ignore - do not document.
 */

export function PickersFadeTransitionGroup(inProps) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiPickersFadeTransitionGroup'
  });
  var children = props.children,
      className = props.className,
      reduceAnimations = props.reduceAnimations,
      transKey = props.transKey;
  var classes = useUtilityClasses(props);

  if (reduceAnimations) {
    return children;
  }

  return (
    /*#__PURE__*/
    _jsx(PickersFadeTransitionGroupRoot, {
      className: clsx(classes.root, className),
      children:
      /*#__PURE__*/
      _jsx(Fade, {
        appear: false,
        mountOnEnter: true,
        unmountOnExit: true,
        timeout: {
          appear: animationDuration,
          enter: animationDuration / 2,
          exit: 0
        },
        children: children
      }, transKey)
    })
  );
}